<template lang='pug'>
.main-app
	.forms(:class='[ { active : forms.length > 0 } ]')
		swiper(
			:options='swiperConfig'
			:active-slide='activeForm'

			@slide-change-transition-end='rejectFormsIfFormsClosed'
		)
			.empty(slot='slide-1')
			space-form(
				v-for='( form, i ) in forms'

				:slot='`slide-${i + 2}`'
				:form='form'
				:key='i'

				@cancel='rejectForm'
			)
	// todo:: bind whatever props
	.drive-link-prompt(:class='{ opened : hasPrompt }')
		.prompt(:class='promptState')
			p.description In order to upload and open files while using the desktop app, the G Drive file path must be set. This can be set in the side bar under settings at a later time.
			p.msg {{ driveLinkMsg }}
			short-text-input.drive-link(
				:options='driveLinkInputOptions'
				v-model='driveLinkInput'
			)
			.buttons
				.button.skip(@click='closeDriveLinkPrompt') Close
				.button.submit(@click='submitDriveLink') {{ submitState === 'loading' ? '' : 'Submit' }}
					.loading-indicator(v-if='submitState === "loading"') Loading
						span .
						span .
						span .


	side-nav
	router-view
</template>

<script>
import SideNav from '@/components/SideNav';
import SpaceForm from '@/components/SpaceForm';
import Swiper from '@/components/Swiper';
import ShortTextInput from '@/components/form-inputs/ShortTextInput';

// eslint-disable-next-line no-unused-vars
import { editUser, GDriveLinkUpdate } from '@/lib/API';
import { RemoveEndSlashes } from '@/lib/utils';
import { GetFirestoreUser } from '@/lib/db/users';
import { _firestore } from '@/lib/db';

export default {
	name : 'app-wrapper',

	data : () => ( {
		activeForm            : 0,
		driveLinkInput        : '',
		submitState           : 'init',
		driveLinkInputOptions : {
			placeholder   : 'e.g. G:',
			minimalLabel  : 'G Drive File Path',
			selectOnFocus : true,
		},
		driveLinkPromptClosed : false,

	} ),

	computed : {

		forms() {
			return this.$store.state.forms;
		},

		swiperConfig() {
			const { length } = this.forms;

			return {
				numberOfSlides : ( length + 1 ),
				config         : {
					// auto initialize this swiper
					init         : true,
					initialSlide : 0,

					// swiper settings
					slidesPerView   : document.body.clientWidth > 500 ? 'auto' : 1, // don't force all slides to be 100vw
					speed           : 400, // ms for when you let go of swipe
					spaceBetween    : 0, // no space between
					resistanceRatio : 0, // stops you from swiping past all slides
					direction       : 'horizontal',
					simulateTouch	  : false,
					threshold       : 50, // min distance for scroll to work
				}
			};
		},

		user() {
			return this.$store.state.user;
		},

		postgresUser() {
			return this.$store.getters.postgresUser.email;
		},

		isElectron() {
			return this.$store.state.isElectron;
		},

		driveLinkState() {
			return this.$store.state.driveLinkState;
		},

		promptState() {
			const { driveLinkState, submitState } = this;

			if ( submitState === 'init' || submitState === 'loading' ) {
				return 'idle';
			}

			return driveLinkState;
		},

		hasPrompt() {
			const { driveLinkPromptClosed, driveLinkState } = this;

			if ( driveLinkState === 'not-electron' || driveLinkState === 'unattempted' ) {
				return false;
			}

			if ( driveLinkPromptClosed ) {
				return false;
			}

			return driveLinkState !== 'valid';
		},

		driveLinkMsg() {
			const { promptState } = this;

			if ( promptState === 'idle' ) {
				return '';
			}

			if ( promptState !== 'valid' ) {
				return 'G Drive file path is invalid';
			}

			return 'G Drive file path is valid';

		}

	},


	watch : {

		forms( forms ) {
			// slide to the active slide when a
			// form is open
			const { length } = forms;
			this.activeForm  = length;
		},

		user( user ) {
			if ( !user.name ) {
				return;
			}

			GetFirestoreUser( user.uid )
				.then( ( fsUser ) => {
					const { driveLinkPromptClosed, driveLink } = fsUser;

					this.driveLinkPromptClosed = !!driveLinkPromptClosed;
					this.driveLinkInput        = driveLink || '';
				} );

		},

		driveLinkState( driveLinkState ) {
			if ( driveLinkState === 'unattempted' ) {
				return;
			}

			if ( driveLinkState === 'valid' ) {
				this.closeDriveLinkPrompt();
			}
		}
	},

	methods : {

		rejectAllForms() {

			this.forms.forEach( form => form.reject() );

		},

		rejectFormsIfFormsClosed( swiper ) {

			const { activeIndex } = swiper;

			const closedForms = this.forms.slice( activeIndex, this.forms.length );
			closedForms.forEach( form => form.reject() );

		},

		rejectForm() {

			if ( this.forms.length === 1 ) {
				this.forms[0].reject();
			}

			this.activeForm -= 1;

		},

		closeDriveLinkPrompt() {
			const { user } = this;
			this.driveLinkPromptClosed = true;

			_firestore
				.collection( 'users' )
				.doc( user.uid )
				.update( {
					driveLinkPromptClosed : this.driveLinkPromptClosed
				} );
		},

		submitDriveLink() {

			if ( this.submitState === 'loading' ) {
				return;
			}

			this.submitState = 'loading';

			this.driveLinkInput = RemoveEndSlashes( this.driveLinkInput );
			// const editedUser = { driveLink : this.driveLinkInput };

			// editUser( { data : editedUser }, this.user.usersKey )
			// 	.then( () => {
			// 		this.submitState = 'idle';
			// 	} )
			// 	.catch( ( err ) => {
			// 		console.warn( err );
			// 		this.submitState = 'idle';
			// 	} );

			const payload = {
				email     : this.postgresUser,
				driveLink : this.driveLinkInput
			};
			GDriveLinkUpdate( payload )
				.then( () => {
					this.submitState = 'valid';
					// update store
					this.$store.commit( 'validateDriveLink', 'valid' );
					this.$store.commit( 'updatePostgresUserGDrive', payload.driveLink );
				} )
				.catch( ( err ) => {
					console.warn( err );
					this.submitState = 'idle';
				} );

			// console.log( this.$store.state );
		}

	},

	components : {
		SideNav,
		SpaceForm,
		Swiper,
		ShortTextInput
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

.main-app {
	display: flex;
	width: 100%;

	.title {
		color: $color-primary;
		text-transform: capitalize;
	}

	.forms {
		z-index: 101;
	}

	.drive-link-prompt {
		position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #757e8b33;
		z-index: 102;
		display: none;

		&.opened {
			display: block;
		}

		.prompt {
			position: absolute;
			background: #ffffff;
			width: 600px;
			left: 50%;
			top: 40%;
			transform: translateX(-50%);
			padding: 25px;

			.description {
				margin-bottom: 15px;
				padding: 0px 15px;
			}

			.msg {
				margin-left: 15px;
				margin-bottom: 15px;
				min-height: 25px;
			}

			.drive-link {
				margin-bottom: 20px;
			}

			.buttons {
				display: flex;
				justify-content: center;

				.button {
					margin: 5px;

					.loading-indicator {
						span {
							color: white;
							font-size: 16px;
						}
					}

					&.skip {
						background: white;
						color: #50606E
					}
				}
			}

			&.invalid {
				.msg {
					color: $error;
				}
			}

			&.valid {
				.msg {
					color: $color-primary;
				}
			}
		}
	}
}
</style>
